import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from "react-loading-skeleton";
import axiosInstance from "./../../helpers/axiosInstance";
import MyModal from "components/Modal/Modal";
import santander from '../../assets/img/brand/santander.png';
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';
import ComponentemodificaUsu from './modificaUsuario.js'


// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { normalizeUnits } from "moment";
import { tr } from "date-fns/locale";
import basePerfiles from "./basePerfiles.js";
import baseUsuarios from "./baseUsu.js";
import { set } from "date-fns";
import baseTransaccionPen from "./baseTransaccionesPen.js";
import { event } from "jquery";

const Confirmmodal=(props)=>{
  
  const [muestramodal,setmuestramodal]=useState(false);
  const [mensajepadre,setmensajepadre]=useState(props.mensaje);
  const [cargando,setcargando]=useState(props.esperando);

  useEffect(()=>{
    if(props.pideconfirm){
      setmuestramodal(true);
    }

  },props.pideconfirm);

  const toggleModal=()=>{
    if(muestramodal){
      setmuestramodal(false);
      props.funcrespadre(false);
    }else{
      setmuestramodal(true);
    }
  }

  
  const salidapadre=()=>{
    setmuestramodal(false);
    props.funcrespadre(true);
  }
  if(cargando==false){
    //toggle={() => toggleModal()}
    return(
      <Modal
        className="modal-dialog-centered"
        contentClassName=""
        isOpen={muestramodal}
      >
        <div className="modal-header"style={{height:"60px",margin:"-15px 0px 0px 285px"}}>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
              <img
                           className=""
                           src={
                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                            }/></span>
          </button>
        </div>
        <div className="modal-body">
          <div className="py-1 text-center">
          <img
              className=""
              src={
                  require("../../assets/img/icons/Icono-Contrasen╠âa-Gris.png")
                  .default
                  }/>                          
            <h4 className="heading mt-4 mb-4">{mensajepadre}</h4>
            <div class="text-center">
              <button  color="white" block size="lg" className="my-title my-1 mt-1 btn bg-success text-white " onClick={salidapadre}>
                Confirmar
                </button>
            </div>
           
          </div>
        </div>
      </Modal>
    )
  }else{
    return(
      <Modal
        className="modal-dialog-centered"
        contentClassName=""
        isOpen={muestramodal}
      >
        <div className="modal-header">
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i className="fas fa-lock ni-3x" />
            <h4 className="heading mt-4">{mensajepadre}</h4>
            <Skeleton height={100} count={2} className="card-transaction-info" style={{ width:"-webkit-fill-available"}}></Skeleton>
          </div>
        </div>
      </Modal>
    )
  }
  
}

export default Confirmmodal;